<template>
  <vx-card slot="no-body" :title="$t('GradeControl.Admin.Title')" class="text-center greet-user" v-show="$auth.checkRoles(gcRoles.collaborators)">
    <menu-control :items="linkItems">
    </menu-control>
  </vx-card>
</template>
<script>
import gcRoles from './../roles.js'
import menuControl from '@/app/shared/components/lists/menu.vue'

export default {
  components: {
    menuControl
  },
  data() {
    return {
      gcRoles,
      linkItems : [ 
        {
          roles : gcRoles.collaborators,
          icon : "LockIcon",
          to : "/geo/gradecontrol/admin/locations",
          i18nTitle : "GradeControl.Location.Title"
        },
        {
          roles : gcRoles.employeesCollaborators,
          icon : "UserIcon",
          to : "/geo/gradecontrol/admin/employees",
          i18nTitle : "GradeControl.Employee.Title"
        },
        {
          roles : gcRoles.collaborators,
          icon : "LockIcon",
          to : "/geo/gradecontrol/admin/equipments",
          i18nTitle : "GradeControl.Equipment.Title"
        },
        {
          roles : gcRoles.collaborators,
          icon : "LockIcon",
          to : "/geo/gradecontrol/admin/mucktypes",
          i18nTitle : "GradeControl.MuckType.Title"
        },
        {
          roles : gcRoles.collaborators,
          icon : "LockIcon",
          to : "/geo/gradecontrol/admin/materialsubtypes",
          i18nTitle : "GradeControl.MaterialSubType.Title"
        },
        {
          roles : gcRoles.collaborators,
          icon : "LockIcon",
          to : "/geo/gradecontrol/admin/destinations",
          i18nTitle : "GradeControl.Destinations.Title"
        }
      ]
    }
  }
};
</script>